import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function FeatureRoute({ feature, children }) {
  const { features } = useAuth();
  if (!features?.[feature]) return <Navigate to={`/account-nodig?feature=${encodeURIComponent(feature)}`} replace />;
  return children;
}
